import { render } from "./TopicSidebar.vue?vue&type=template&id=1434f3c2&scoped=true"
import script from "./TopicSidebar.vue?vue&type=script&lang=js"
export * from "./TopicSidebar.vue?vue&type=script&lang=js"

import "./TopicSidebar.vue?vue&type=style&index=0&id=1434f3c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1434f3c2"]])

export default __exports__